import { startMining_2, getUserBalance } from '../../../Services/Requests';

export class StartMiningService {
  static async start() {
    try {
      console.log('Начинаем первый майнинг...');
      const response = await startMining_2();
      console.log('Ответ от сервера после старта майнинга:', response);
      
      // Обновляем баланс после старта
      await getUserBalance();
      
      return response;
    } catch (error) {
      console.error("Ошибка при запуске майнинга:", error);
      throw error;
    }
  }
} 